
import VEmptyState from "@/vuetify-extensions/VEmptyState.vue";
import {
  Vue,
  Component,
  Prop,
  Ref,
  PropSync,
  Watch,
} from "vue-property-decorator";

type Loader = (
  page: number,
  size: number
) => Promise<{ hasNextPage: boolean; data: any[] }>;

@Component({
  inheritAttrs: true,
  components: {
    VEmptyState,
  },
})
export default class VScrollView extends Vue {
  @Prop({
    type: String,
    default: "div",
  })
  component!: string;

  @Prop({
    type: Array,
    default: () => [],
  })
  rules!: Array<(item: any, index?: number) => boolean>;

  @Prop({
    type: Function,
    default: () => null,
  })
  loader!: Loader;

  @Prop({
    type: Boolean,
    default: true,
  })
  scrollWithDocument!: boolean;

  @Prop({
    type: Number,
    default: 20,
  })
  size!: number;

  @PropSync("refresh", {
    type: Boolean,
    default: false,
  })
  refreshSync!: boolean;

  @Ref()
  container!: HTMLElement;

  content: Window | HTMLElement | null = null;
  data: any[] = [];
  hasNextPage!: boolean;
  page = 1;
  loading = true;

  get filteredData() {
    return this.data.filter((item, index) => {
      let flag = true;
      for (const rule of this.rules) {
        flag = flag && rule(item, index) === true;
      }
      return flag;
    });
  }

  async loadItems(refresh: boolean = false) {
    if (refresh) {
      this.page = 1;
      this.data = [];
    }
    this.loading = true;
    try {
      const response = await this.loader(this.page, this.size);
      this.data.push(...response.data);
      this.hasNextPage = response.hasNextPage;
      this.page++;
      this.loading = false;
    } catch (e) {
      this.data = [];
      this.page = 1;
      this.hasNextPage = false;
      this.loading = false;
    }
  }

  async loadMoreData(event: Event | TouchEvent) {
    this.content!.removeEventListener("scroll", this.loadMoreData);
    this.content!.removeEventListener("touchmove", this.loadMoreData);
    var target = this.scrollWithDocument
      ? document.scrollingElement
      : event.target;
    const scrollHeight = (target as HTMLElement).scrollHeight;
    const clientHeight = (target as HTMLElement).clientHeight;
    const scrollTop = (target as HTMLElement).scrollTop;
    if (scrollHeight <= clientHeight + scrollTop + 100 && this.hasNextPage) {
      await this.loadItems();
    }
    this.content!.addEventListener("scroll", this.loadMoreData);
    this.content!.addEventListener("touchmove", this.loadMoreData);
  }

  @Watch("refresh")
  onRefreshChange() {
    if (this.refreshSync) {
      this.loadItems(this.refreshSync);
      this.refreshSync = false;
    }
  }

  mounted() {
    this.content = this.scrollWithDocument
      ? window
      : this.container.parentElement;
    this.content!.addEventListener("scroll", this.loadMoreData);
    this.content!.addEventListener("touchmove", this.loadMoreData);
    this.loadItems(true);
  }
  beforeDestroy() {
    this.content!.removeEventListener("scroll", this.loadMoreData);
    this.content!.removeEventListener("touchmove", this.loadMoreData);
  }
}
